import React from 'react';
import Admin from "./admin";

const App = () => <Admin />;

export default App;
